import classNames from 'classnames';
import { Field } from 'formik';
import React, { useCallback, useState } from 'react';
import { ReactComponent as CopyIcon } from './../../assets/copy.svg';
import { ReactComponent as CopiedIcon } from './../../assets/copied.svg';

const Link = ({ link, i, errors, touched, name, readOnly = false }) => {
    const [isCopied, setIsCopied] = useState(false);

    const fieldClass = classNames({
        'portfolio-field-wrapper': true,
        'portfolio-link-href': true,
        'portfolio-link-error': errors[name]?.[i] && touched[name]?.[i],
        'portfolio-copied-field': readOnly,
    });

    const handleCopyToClipboard = useCallback(() => {
        if (readOnly) {
            window.navigator.clipboard.writeText(link.link);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 1500);
        }
    }, [link, readOnly]);

    return (
        <li className="portfolio-link-wrap">
            <div className="portfolio-field-wrapper portfolio-link-name">{link.name}</div>
            <div className={fieldClass} onClick={handleCopyToClipboard}>
                {readOnly ? (
                    <>
                        <input readOnly value={link.link} />
                        {isCopied ? <CopiedIcon /> : <CopyIcon />}
                    </>
                ) : (
                    <Field name={`${name}[${i}].link`} placeholder="https://" />
                )}
            </div>
        </li>
    );
};

export default Link;
